module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": "",
      "container--fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": _vm.breadCrumbsItems,
      "divider": ">"
    }
  })], 1)], 1), _vm._v(" "), _c('summary-of-account', {
    attrs: {
      "filterUsers": _vm.filterUser,
      "userType": "AM"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09b6fc30"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/AMDashboard/spendRevenue.vue
// module id = 1994
// module chunks = 0